import React from 'react'
import { DatePicker, DatePickerProps, Form } from 'antd'
import dayjs from 'dayjs'
import { CSSProperties } from 'react'
import './InputDatePicker.less'
import updateLocale from 'dayjs/plugin/updateLocale'

dayjs.extend(updateLocale)

export type InputDatePickerProps = {
  onChange?: (value: unknown | null, dateString: string) => void
  format?: string
  value?: string | null
  futureDate?: boolean
  suffixIcon?: string | null
  pastDate?: boolean
  label?: string
  required?: boolean
  localization?: { placeholder?: string; errorMessage: string }
  style?: CSSProperties
  type?: string
  disabled?: boolean
  defaultValue?: DatePickerProps['defaultValue']
  disabledDate?: DatePickerProps['disabledDate']
  wrapFormItem?: boolean
}
function InputDatePicker({
  onChange,
  format = 'DD-MM-YYYY',
  value,
  futureDate,
  pastDate,
  suffixIcon = null,
  label,
  required,
  localization,
  style,
  type,
  disabled,
  defaultValue,
  disabledDate: propsDisabledDate,
  wrapFormItem = true
}: InputDatePickerProps) {
  const disablePastDates = (current: dayjs.Dayjs) =>
    current && current < dayjs().startOf('day')

  const disableFutureDates = (current: dayjs.Dayjs) =>
    current && current > dayjs().endOf('day')

  dayjs.updateLocale('en', {
    // @ts-ignore
    week: { dow: 1 }
  })

  const displayedValue = value ? dayjs(value) : null

  const disabledDate =
    propsDisabledDate ||
    (futureDate ? disablePastDates : undefined) ||
    (pastDate ? disableFutureDates : undefined)

  const childrenDatePicker = (
    <DatePicker
      disabled={disabled}
      className="lmc-antd-date-picker"
      disabledDate={disabledDate}
      popupClassName="lmc-antd-date-picker-dropdown"
      format={format}
      // @ts-ignore Not sure where this comes from?
      onChange={onChange}
      suffixIcon={suffixIcon}
      defaultValue={defaultValue}
      value={displayedValue}
      placeholder={localization?.placeholder || undefined}
    />
  )

  if (!wrapFormItem) {
    return (
      <div id="date" style={style}>
        {childrenDatePicker}
      </div>
    )
  }

  return (
    <div id="date" style={style}>
      <Form.Item
        label={label}
        name={type || 'date-picker'}
        rules={[
          {
            required,
            message: localization?.errorMessage || 'Please enter a date!'
          }
        ]}
        initialValue={displayedValue}
      >
        {childrenDatePicker}
      </Form.Item>
    </div>
  )
}

export default InputDatePicker
